import {
  optimisticChatMessageRemoved,
  selectIsMessageOptimistic,
  selectOptimisticImageBlobs,
} from 'features/chat/chatSlice';
import { chatImageUploadFailed } from 'features/chat/actions';
import { call, put, select } from 'redux-saga/effects';
import { revokeBlobUrls } from 'features/chat/utils/revokeBlobUrls';
import { chatImageUploadManager } from 'utils/chat-image-upload/ChatImageUploadManager';

export function* onChatImageUploadFailedSaga(action: ReturnType<typeof chatImageUploadFailed>) {
  const { messageId } = action.payload;

  const isStillOptimistic: boolean = yield select(selectIsMessageOptimistic, messageId);
  if (!isStillOptimistic) {
    return;
  }

  const blobsToRevoke: string[] | undefined = yield select(selectOptimisticImageBlobs, messageId);
  yield put(optimisticChatMessageRemoved(messageId));
  if (blobsToRevoke) {
    yield call(revokeBlobUrls, blobsToRevoke);
  }
  yield call(chatImageUploadManager.cancelByMessageId, messageId);
}
